import { Section, Eyebrow } from "./Section"

export function Founder() {
  return (
    <Section>
      <div className="grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:items-center lg:gap-14">
        <div className="order-1 lg:order-none">
          <img
            src="/harry-duran.jpg"
            alt="Harry Duran, founder of FullCast"
            className="aspect-[4/5] w-full max-w-sm rounded-2xl border border-hairline object-cover"
            loading="lazy"
          />
        </div>

        <div>
          <Eyebrow>Founder-led</Eyebrow>
          <h2 className="display-2 mt-4">Founder-led. System-driven. Built with care.</h2>
          <p className="mt-5 text-lg text-ink-body">
            FullCast is intentionally boutique. You're not handed off to a
            bloated production machine or a junior account manager. The system is
            led by Harry Duran, a podcast host and agency founder with more than a
            decade of experience launching, producing, and growing
            authority-building shows.
          </p>
          <p className="mt-4 text-ink-muted">
            Harry has hosted Podcast Junkies since 2014 and founded FullCast in
            2015. Since then, FullCast has helped launch more than 130 podcasts
            for founders, coaches, consultants, and expert-led brands. Harry also
            hosts the Vertical Farming Podcast, where he has generated more than
            $100K in sponsorship revenue through a niche, relationship-driven
            podcast strategy.
          </p>
        </div>
      </div>
    </Section>
  )
}
